/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'

export default class TableResponsive {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.clearStyles()
    this.createTHead()
    this.createDataTitles()
  }

  clearStyles() {
    this.$element
      .removeAttr('style')
      .removeAttr('width')
      .removeAttr('height')
      .removeAttr('border')
    jQuery('*', this.$element).removeAttr('style').removeAttr('valign')
  }

  createTHead() {
    jQuery('<thead></thead>').prependTo(this.$element)
    this.$element
      .find('tbody')
      .find('tr')
      .eq(0)
      .appendTo(jQuery('thead', this.$element))

    jQuery('thead', this.$element).html(function (id, html) {
      // you might use callback to set html in jquery
      // replace td by th
      return html.replace(/td>/g, 'th>')
      // use regExp to replace all
    })
  }

  createDataTitles() {
    jQuery('th', this.$element).each((indexTH, elementTH) => {
      const txt = jQuery.trim(jQuery(elementTH).text())

      jQuery('tbody tr', this.$element).each((indexTR, elementTR) => {
        jQuery(elementTR).find('td').eq(indexTH).attr('data-title', txt)
      })
    })
  }
}
